// src/App.js
import React, { useState } from 'react';
import ChatApp from './Components/ChatApp';

const App = () => {


  return (
    <div>
      <ChatApp />
    </div>
  );
};

export default App;
